import * as yup from 'yup';

export const validationSchema = yup.object({
    contact: yup
        .string()
        .required('Заполните поле')
        .test('contact', 'Неверный формат', (value: string | any): boolean => {
            const regexMail =
                /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
            const regexPhone =
                /^(\+7|7|8)?[\s-]?\(?[489][0-9]{2}\)?[\s-]?[0-9]{3}[\s-]?[0-9]{2}[\s-]?[0-9]{2}$/;
            return regexMail.test(value) || regexPhone.test(value);
        }),
    message: yup.string(),
});
